// Where uploaders are sent when processing fails and re-uploading does not help.
export const supportEmail: string = import.meta.env.VITE_SUPPORT_EMAIL || 'hello@roadfootage.com.au'
